import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import RespondentFlowApi from "../services/respondentFlow.api";
import LoggerService from "../services/logger.service";
import { SCREENER_ROUTE, ERROR_ROUTE } from "../constants/routes.constants";
import FinSurveyPng from "../assests/magnifying-glass-icon.gif";
import {
  SURVEY_SCREENER_FAILED_SUPPLIER_REDIRECT,
  SURVEY_SCREENER_NOT_REQUIRED,
  SURVEY_SCREENER_PASSED,
  SURVEY_SCREENING,
  SURVEY_SCREENING_FAILED_RESET_QUES,
  SURVEY_SCREENER_PASSED_CLIENT_REDIRECT,
} from "../constants/event.constants";
import { Backdrop, CircularProgress, TextField } from "@mui/material";
import { BounceLoader } from "react-spinners";
import CommonFormLayout from "../components/CommonFormLayout";
import TextInputComponent from "../components/TextFieldInput";
import CheckboxInputComponent from "../components/CheckboxInput";
import RadioInputComponent from "../components/RadioInput";
import LoaderComponent from "../components/LoaderComponent";
import FormSkeleton from "../components/question-components/form-skeleton";
import FormWrapper from "../components/question-components/form-wrapper";
import SingleSelectQuestion from "../components/question-components/single-select";
import TextFieldQuestion from "../components/question-components/text-field";
import MultiSelectQuestion from "../components/question-components/multi-select";
import ButtonV2 from "../components/question-components/button";
import { LOG_EVENTS } from "../constants/logs.constants";
import { SessionUtils } from "../utils/session.utils";
import { loadVerisoulScript } from "../services/verisoul.script";

const Start = () => {
  const [Loader, setLoader] = useState(true);
  const [ErrorMessage] = useState("");
  const [idx, setIdx] = useState(0);
  const [obj, setObj] = useState({});
  const [match, setMatch] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [errorIndex, setErrorIndex] = useState("");
  const [questions, setQuestions] = useState([]);
  // const [sessionParams, setSessionParams] = useState(null);
  const [surveyId, setSurveyId] = useState(undefined);

  let navigate = useNavigate();

 const verisolAccount = async (userId,surveyId) => {
    await window.Verisoul?.account({
      id: `${userId}-${surveyId}`,
      group: surveyId.toString() ?? "",
    });
  };

  let getVerisolSession = async (userId,surveyId) => {
    try {
      if (!window.Verisoul) return null;
      await verisolAccount(userId,surveyId);
      const { session_id } = await window.Verisoul.session();
      return session_id;
    } catch (e) {
      console.log(e);
      return null;
    }
  };

  let getDynamicProfiling = async () => {
    setLoader(true);
    let storedParam = JSON.parse(sessionStorage.getItem("params"));
    try {
      let reqObj = {};
      reqObj.token = storedParam.token;
      reqObj.userId = storedParam.userId;

      //get security config
      
      let securityConfig = await RespondentFlowApi.post("/v1/landing/security/config", {token:reqObj.token});
      debugger;
      
      if(securityConfig?.verisoulEnabled) {
        try {
          await loadVerisoulScript(securityConfig.verisoulProjectId);
        } catch (e) {
          console.log("Verisoul script failed to load", e);
        }
        let vSession = await getVerisolSession(securityConfig.userId,securityConfig.surveyId);
        reqObj.verisolSessionId = vSession;
      }


      // reqObj.verisolSessionId = await getVerisolSession(reqObj.userId);
      reqObj.paramList = storedParam.paramList;
      reqObj.newToken = storedParam.isEnding ? storedParam.isEnding : false;
      if (reqObj.newToken) {
        reqObj.allSurveys = false;
      } else {
        reqObj.allSurveys = true;
      }

      LoggerService.logEvent(LOG_EVENTS.SURVEY_QUESTION_REQUEST);

      let resp = await RespondentFlowApi.post("/v1/profiling/dynamic", reqObj);
      if (resp.token) SessionUtils.setRespondentToken(resp.token);
      LoggerService.logEvent(LOG_EVENTS.SURVEY_QUESTION_RECEIVED, undefined, { eventType: resp.eventType });
      // if (resp.isInternalRedirect) {
      let obj = {};
      obj.eventType = resp.eventType;
      obj.token = resp.token;
      obj.userId = resp.userId;
      obj.questionList = resp.questionList;
      //TODO:: get campaignUid from params

      if (obj.eventType == SURVEY_SCREENING) {
        setQuestions(resp.questionList);
        setSurveyId(resp.surveyId);
        setLoader(false);
      } else if (obj.eventType == SURVEY_SCREENER_PASSED_CLIENT_REDIRECT) {
        await LoggerService.logEvent(LOG_EVENTS.SURVEY_REDIRECT_TO_CLIENT);
        await LoggerService.logEvent(LOG_EVENTS.JOURNEY_CLIENT_REDIRECT);

        sessionStorage.removeItem("params");
        window.location.href = `${resp.redirectUrl}`;
        setLoader(true);
      } else if (obj.eventType == SURVEY_SCREENER_FAILED_SUPPLIER_REDIRECT) {
        setLoader(true);
        await LoggerService.logEvent(LOG_EVENTS.SURVEY_REDIRECT_TO_SUPPLIER);
        await LoggerService.logEvent(LOG_EVENTS.JOURNEY_END, "Redirected to supplier from start");
        sessionStorage.removeItem("params");
        window.location.href = `${resp.redirectUrl}`;
      }
    } catch (e) {
      console.log(e);
      sessionStorage.removeItem("params");
      LoggerService.logEvent(LOG_EVENTS.SURVEY_ERROR, "Error in dynamic profiling: " + (e?.message || String(e)));
      navigate(ERROR_ROUTE);
    }
  };

  useEffect(() => {
    getDynamicProfiling();
  }, []);

  let saveRsponse = async (event) => {
    event.preventDefault();
    setMatch(false);
    let params = sessionStorage.getItem("params");
    let paramObj = JSON.parse(params);
    if (errorIndex === "") {
      setIsLoading(true);
      let reqObj = {};
      reqObj.userId = paramObj.userId;
      reqObj.token = paramObj.token;
      reqObj.surveyId = surveyId;
      reqObj.newToken = paramObj.isEnding ? paramObj.isEnding : false;
      reqObj.responses = [
        {
          id: obj.id,
          answerText: obj.answerText,
          answerId: obj.answerId,
        },
      ];
      if (questions.length - 1 === idx) {
        reqObj.isLastQuestion = true;
      } else {
        reqObj.isLastQuestion = false;
      }
      LoggerService.logEvent(LOG_EVENTS.SURVEY_ANSWER_SENT, undefined, { questionIndex: idx, questionId: obj.id });

      try {
        let response = await RespondentFlowApi.post(`/v1/profiling/d/response`, reqObj);
        if (response.token) SessionUtils.setRespondentToken(response.token);

        if (response.status === false) {
          if (response.eventType === SURVEY_SCREENING) {
            setQuestions(response.questionList);
            setSurveyId(response.surveyId);
            setIdx(0);
            setErrorIndex("");
            setMatch(true);
            setIsLoading(false);
          } else if (response.eventType === SURVEY_SCREENER_FAILED_SUPPLIER_REDIRECT) {
            setIsLoading(true);
            await LoggerService.logEvent(LOG_EVENTS.SURVEY_REDIRECT_TO_SUPPLIER, "Terminated - no further survey match");
            await LoggerService.logEvent(LOG_EVENTS.JOURNEY_END, "Redirected to supplier from start (terminated)");
            sessionStorage.removeItem("params");
            window.location.href = `${response.redirectUrl}`;
          }
        } else {
          if (response.eventType === SURVEY_SCREENING) {
            // is Last question

            if (questions.length - 1 === idx) {
            } else {
              setErrorIndex("");
              setIdx(idx + 1);
              setMatch(true);
              setIsLoading(false);
            }
          } else if (response.eventType === SURVEY_SCREENER_PASSED_CLIENT_REDIRECT) {
            LoggerService.logEvent(LOG_EVENTS.SURVEY_REDIRECT_TO_CLIENT);
            LoggerService.logEvent(LOG_EVENTS.JOURNEY_CLIENT_REDIRECT);
            window.location.href = `${response.redirectUrl}`;
          }
        }
      } catch (e) {
        console.error(e);
        LoggerService.logEvent(LOG_EVENTS.SURVEY_ERROR, "Error saving dynamic profiling response: " + (e?.message || String(e)));
        setIsLoading(false);
        navigate(ERROR_ROUTE);
      }
    }
  };

  useEffect(() => {
    if (questions.length > 0 && questions[idx]) {
      setObj(JSON.parse(JSON.stringify(questions[idx])));
    }
    // eslint-disable-next-line
  }, [questions, idx]);

  useEffect(() => {
    if (obj.type === 3 || obj.type === 4) {
      if (
        !obj?.answerText ||
        obj?.answerText === null ||
        obj?.answerText === "" ||
        (obj.id === 59 && obj?.answerText > 99) ||
        (obj.id === 59 && obj?.answerText < 18)
      ) {
        setErrorIndex(obj.id);
      } else {
        setErrorIndex("");
      }
    } else {
      if (!obj?.answerId || obj?.answerId?.length === 0) {
        setErrorIndex(obj.id);
      } else {
        setErrorIndex("");
      }
    }

    // eslint-disable-next-line
  }, [obj]);

  const responsequestions = (e) => {
    e.preventDefault();
  };

  return (
    <div>
      {Loader || isLoading ? (
        <FormSkeleton />
      ) : (
        // <form
        // onSubmit={Loader || isLoading ? responsequestions : saveRsponse}
        // noValidate
        //   className="max-w-3xl mx-auto w-full h-[100dvh] py-2 relative"
        // >
        //   <CommonFormLayout
        //     key={questions[idx]?.id || idx}
        //     header={<h2 className="text-base font-semibold">{questions[idx]?.text}</h2>}
        //     description={
        //       !match && errorIndex === questions[idx]?.id ? (
        //         <span className="text-xs text-red-500">This field is required!</span>
        //       ) : (
        //         ""
        //       )
        //     }
        //     footer={
        //       <div className="flex justify-end">
        // <button type="submit" className="button" onClick={() => setMatch(false)}>
        //   Next
        // </button>
        //       </div>
        //     }
        //   >
        //     {(questions.length > 0 && questions[idx] && questions[idx] && questions[idx].type === 4) ||
        //     (questions.length > 0 && questions[idx] && questions[idx] && questions[idx].type === 3) ? (
        //       <TextInputComponent
        //         variant="outlined"
        //         id={questions[idx]?.id}
        //         label={questions[idx]?.text}
        //         value={obj?.answerText}
        //         onChange={(e) => {
        //           let payload = { ...obj };
        //           payload.answerText = e.target.value;
        //           setObj(JSON.parse(JSON.stringify(payload)));
        //         }}
        //         error={!match && errorIndex === questions[idx]?.id ? true : false}
        //         helperText={
        //           !match && errorIndex === questions[idx]?.id && obj.answerText > 99
        //             ? "This value not be greater then 100 and"
        //             : obj.answerText < 18
        //             ? "This value not be Less then 18"
        //             : "This field is required!"
        //         }
        //       />
        //     ) : questions.length > 0 && questions[idx] && questions[idx].type === 1 ? (
        //       <div
        //         className={
        //           questions[idx]?.options.length > 12
        //             ? "grid md:grid-cols-2 gap-4 grid-cols-1 mt-2"
        //             : "grid md:grid-cols-1 gap-4 grid-cols-1 mt-2"
        //         }
        //       >
        //         {questions.length > 0 &&
        //           questions[idx].options.map((item) => (
        //             <div className="flex space-x-3 justify-start" key={item.id}>
        //               <RadioInputComponent
        //                 id={`radio_${item.id}`}
        //                 name={obj?.id}
        //                 label={item.text}
        //                 value={item.id}
        //                 checked={obj?.answerId?.includes(item.id)}
        //                 onChange={(e) => {
        //                   let payload = { ...obj };
        //                   if (e.target.checked) {
        //                     payload.answerId = [item.id];
        //                   } else {
        //                   }
        //                   setObj(JSON.parse(JSON.stringify(payload)));
        //                 }}
        //               />
        //             </div>
        //           ))}
        //       </div>
        //     ) : (
        //       <div
        //         className={
        //           questions[idx]?.options.length > 12
        //             ? "grid md:grid-cols-2 gap-4 grid-cols-1 mt-2"
        //             : "grid md:grid-cols-1 gap-4 grid-cols-1 mt-2"
        //         }
        //       >
        //         {questions.length > 0 &&
        //           questions[idx].options.map((item) => (
        //             <div className="flex space-x-3 justify-start" key={item.id}>
        //               <CheckboxInputComponent
        //                 id={`checkbox_${item.id}`}
        //                 name={obj?.id}
        //                 label={item.text}
        //                 value={item.id}
        //                 checked={obj?.answerId?.includes(item.id)}
        //                 onChange={(e) => {
        //                   let payload = { ...obj };
        //                   if (e.target.checked) {
        //                     payload.answerId = [item.id];
        //                   } else {
        //                   }
        //                   setObj(JSON.parse(JSON.stringify(payload)));
        //                 }}
        //               />
        //             </div>
        //           ))}
        //       </div>
        //     )}
        //   </CommonFormLayout>
        // </form>
        <form
          className=" w-full h-[100dvh]"
          onSubmit={Loader || isLoading ? responsequestions : saveRsponse}
          noValidate
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              const form = e.currentTarget;
              form.requestSubmit();
            }
          }}
        >
          <FormWrapper
            footer={
              // <button type="submit" className="button" onClick={() => setMatch(false)}>
              //   Next
              // </button>
              <ButtonV2 type="submit" onClick={() => setMatch(false)}>
                Next
              </ButtonV2>
            }
          >
            {questions.length > 0 &&
              questions[idx] &&
              (() => {
                const value = questions[idx];
                const hasError = !match && errorIndex === value.id;

                return (
                  <>
                    {value.type === 1 && (
                      <SingleSelectQuestion
                        question={{
                          id: value.id,
                          label: value.text,
                          options: value.options,
                          description: hasError ? "This field is required!" : null,
                          required: false,
                        }}
                        value={value.answerId?.[0]}
                        onChange={(selected) => {
                          const payload = [...questions];
                          payload[idx].answerId = [selected];
                          setQuestions(payload);
                        }}
                      />
                    )}

                    {(value.type === 3 || value.type === 4) && (
                      <TextFieldQuestion
                        question={{
                          id: value.id,
                          label: value.text,
                          required: false,
                          description: hasError ? "This field is required!" : null,
                          type: value.type,
                        }}
                        value={value.answerText ?? ""}
                        onChange={(val) => {
                          const payload = [...questions];
                          payload[idx].answerText = val;
                          setQuestions(payload);
                        }}
                        error={hasError}
                        helperText={
                          hasError
                            ? value.id === 59
                              ? Number(value.answerText) > 99
                                ? "This value cannot be greater than 100."
                                : Number(value.answerText) < 18
                                ? "This value cannot be less than 18."
                                : "This field is required!"
                              : "This field is required!"
                            : ""
                        }
                      />
                    )}

                    {value.type === 2 && (
                      <MultiSelectQuestion
                        question={{
                          id: value.id,
                          label: value.text,
                          options: value.options,
                          required: false,
                          description: hasError ? "This field is required!" : null,
                        }}
                        value={value.answerId ?? []}
                        onChange={(selectedValues) => {
                          const payload = [...questions];
                          payload[idx].answerId = selectedValues;
                          setQuestions(payload);
                        }}
                      />
                    )}
                  </>
                );
              })()}
          </FormWrapper>
        </form>
      )}
    </div>
  );
};

export default Start;
